import InverstorFAQs from './InverstorFAQs'

export default InverstorFAQs
